import { render } from "./CustomLayoutWithOverflow.vue?vue&type=template&id=105cca42&scoped=true&ts=true"
import script from "./CustomLayoutWithOverflow.vue?vue&type=script&lang=ts"
export * from "./CustomLayoutWithOverflow.vue?vue&type=script&lang=ts"

import "./CustomLayoutWithOverflow.vue?vue&type=style&index=0&id=105cca42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105cca42"]])

export default __exports__